// ハンバーガーメニュー
document.getElementById("hamb-open").addEventListener("click", function(event) {
  event.stopPropagation();
  document.getElementById("hamb-menu").classList.add("active");
  document.querySelector(".body").classList.add("no_scroll");
});

document.getElementById("hamb-menu__close").addEventListener("click", function(event) {
  event.stopPropagation();
  document.getElementById("hamb-menu").classList.remove("active");
  document.querySelector(".body").classList.remove("no_scroll");
});

document.addEventListener("click", function(event) {
  if (!document.getElementById("hamb-menu").contains(event.target) && !document.getElementById("hamb-open").contains(event.target)) {
    document.getElementById("hamb-menu").classList.remove("active");
    document.querySelector(".body").classList.remove("no_scroll");
  }
});

// スクロールするとヘッダーfixed
window.onscroll = function() {toggleFixedHeader()};
function toggleFixedHeader() {
    var header = document.getElementById("myHeader");
    if (window.pageYOffset > 38) {
        header.classList.add("fixed-header");
    } else {
        header.classList.remove("fixed-header");
    }
}

document.addEventListener('DOMContentLoaded', function() {
  var topButton = document.querySelector('.cc-top-wrap');

  topButton.addEventListener('click', function() {
      window.scrollTo({
          top: 0,
          behavior: 'smooth'
      });
  });
});

// スムーススクロール
document.querySelectorAll('a[href^="#"]').forEach(anchor => {
  anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const speed = 600;
      const headerHeight = 74;  // ヘッダーの高さ
      const href = this.getAttribute("href");
      const target = document.querySelector(href === "#" || href === "" ? "html" : href);
      
      if (target) {
          const position = target.offsetTop - headerHeight;
          window.scrollTo({
              top: position,
              behavior: "smooth"
          });
      }
  });
});

// FAQ
document.querySelectorAll('.cc-faq__list-q').forEach(function(question) {
  question.addEventListener('click', function() {
    const parent = question.parentElement;
    
    // 他のアクティブな項目を閉じる（オプション）
    document.querySelectorAll('.cc-faq__list').forEach(function(listItem) {
      if (listItem !== parent) {
        listItem.classList.remove('active');
      }
    });

    // クリックした項目を切り替え
    parent.classList.toggle('active');
  });
});

// search-modal
document.getElementById('search-button').addEventListener('click', function(event) {
  event.stopPropagation();
  document.querySelector('.cc-search-modal').classList.add('is-active');
  document.querySelector('.js-modal-overlay').classList.add('is-active');
  document.querySelector(".body").classList.add("no_scroll");
});

document.querySelector(".js-modal-overlay").addEventListener("click", function(event) {
  event.stopPropagation();
  document.querySelector('.cc-search-modal').classList.remove('is-active');
  document.querySelector('.js-modal-overlay').classList.remove('is-active');
  document.querySelector(".body").classList.remove("no_scroll");
});

// camperspickモーダル
document.querySelectorAll('.cc-page-camperspick__item').forEach(function(item, index) {
  item.addEventListener('click', function(event) {
    event.stopPropagation();
    // indexを使って対応するpopupを取得
    const popup = document.querySelectorAll('.cc-page-camperspick__item-popup')[index];
    popup.classList.add('is-active');
    document.querySelector('.js-modal-overlay__camperspick').classList.add('is-active');
    document.querySelector(".body").classList.add("no_scroll");
  });
});

document.querySelector(".js-modal-overlay__camperspick").addEventListener("click", function(event) {
  event.stopPropagation();
  // 全てのポップアップからis-activeを削除
  document.querySelectorAll('.cc-page-camperspick__item-popup').forEach(function(popup) {
    popup.classList.remove('is-active');
  });
  document.querySelector('.js-modal-overlay__camperspick').classList.remove('is-active');
  document.querySelector(".body").classList.remove("no_scroll");
});


// フェードインアニメーション
// 要素が画面に表示されたかを確認する関数
function isInViewport(element) {
  const rect = element.getBoundingClientRect();
  return (
    rect.top < (window.innerHeight || document.documentElement.clientHeight) &&
    rect.bottom > 0 &&
    rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
    rect.right > 0
  );
}

// スクロールイベントのリスナーを追加
window.addEventListener('scroll', function() {
  const fadeLeftElements = document.querySelectorAll('.fadeLeft');

  fadeLeftElements.forEach(function(element) {
    if (isInViewport(element)) {
      element.classList.add('fadeIn');
    }
  });
});

// 初回ロード時にも表示されている要素があればアニメーションを適用
document.addEventListener('DOMContentLoaded', function() {
  const fadeLeftElements = document.querySelectorAll('.fadeLeft');

  fadeLeftElements.forEach(function(element) {
    if (isInViewport(element)) {
      element.classList.add('fadeIn');
    }
  });
});